/* global s */
'use strict';

class TariffPlan {
	constructor(options) {
		this.defaults = {
			tariff_plan_country_list: {},
			tariff_plans: [],
			selected_country: '',
			selected_value: '',
			cached_rates: {},
			featured: false,
			tracking_params: {
				destination: 'Other',
				product_type: '',
				product_details: ''
			},
			page_selectors: {
				plan_sell_countries_id: 'plan-sell-countries',
				best_offer_text_holder: 'plan-subtitle',
				product_selector_id: 'product-selector-plan'
			},
			plan_selectors: {
				plan_option: '.plan-option',
				left_top: '.plan-left-top',
				left_bottom: '.plan-left-bottom',
				middle: '.plan-middle',
				right_top: '.plan-right-top',
				right_top_value: '.plan-right-top-value',
				right_top_text: '.plan-right-top-text',
				right_bottom: '.plan-right-bottom',
				container: '#buy-plan-container'
			},
			buy_form_selectors: {
				voice_quantity: 'voice_quantity',
				voice_product_id: 'voice_product_id',
				form_buy_voice: 'form_buy_voice',
				buy_button_id: 'buy-button'
			}
		};
		this.options = Object.assign(this.defaults, options);
		console.log('TariffPlan::constructor(%o)', this.options);
		this.pageEvents();
	}

	/**
	 * Displays the plans for a specific country.
	 * Fills the placeholders in plan_placeholder.html with the necessary details
	 * Calls highlightBestDeal to mark the best deal plan
	 *
	 * @param {string}   countryCode    Country code for the country to display the plans foe
	 * @param {boolean}  featured        Feature the plans section
	 *
	 */

	displayCountryPlans(countryCode, featured) {
		//console.log('TariffPlan::displayCountryPlans(%o, %o)', country_code, featured);
		document.querySelector(this.options.plan_selectors.container).innerHTML = '';
		if (countryCode) {
			countryCode = countryCode.toUpperCase();
			if (this.options.tariff_plans[countryCode]) {
				const planTemplate = document.createElement('template');
				planTemplate.innerHTML = s.options.plan_placeholder.html;

				this.options.tariff_plans[countryCode].forEach(plan => {
					let formattedLeftTop, formattedLeftBottom = '', formattedMiddle = '',
						formattedRightTopValue, formattedRightTopText, formattedRightBottom;
					let newPlanTemplate = planTemplate.cloneNode(true).content.firstElementChild;

					if (plan.max_discount !== 0) {
						let oldval = document.createElement('span');
						if (s.format_money(plan.price_per_month) !== s.format_money(plan.price - plan.max_discount)) {
							oldval.innerHTML = s.format_money(plan.price_per_month);
							oldval.style.textDecoration = 'line-through';
						}
						if (plan.billing_interval_months > 1) {
							formattedMiddle = `${oldval.outerHTML} ${s.format_money(plan.price - plan.max_discount)}${s.it('PER_MONTH')}`;
						} else {
							formattedRightBottom = `${oldval.outerHTML} ${s.format_money(plan.price - plan.max_discount)}${s.it('PER_MONTH')}`;
						}
					} else {
						if (plan.billing_interval_months > 1) {
							formattedMiddle = `${s.format_money(plan.price_per_month)}${s.it('PER_MONTH')}`;
						} else {
							formattedRightBottom = `${s.format_money(plan.price_per_month)}${s.it('PER_MONTH')}`;
						}
					}

					formattedLeftTop = `${plan.translated_name}`;
					if (Number(plan.minutes) === 0) {
						formattedRightTopValue =
							s.svg('icon-infinity', '0 0 88 41', ['color-white', 'icon-infinity']);
					} else {
						formattedMiddle = `${s.format_money(plan.price_per_minute * 100, true, 1)}${s.it('PER_MIN')}`;
						formattedRightTopValue = plan.minutes;
					}
					if (plan.billing_interval_months > 1) {
						formattedLeftBottom = s.it('NO_OF_MONTHS', {'no_of_months' : plan.billing_interval_months});
						formattedRightTopValue =
							s.svg('icon-infinity', '0 0 88 41', ['color-white', 'icon-infinity']);
						formattedRightBottom = `${s.format_money(plan.price)}/${s.it('NO_OF_MONTHS', {'no_of_months' : plan.billing_interval_months})}`;
					}

					formattedRightTopText = ` ${s.it('MIN')}`;

					if (plan.billing_interval_months === 1) {
						const rightBottom = newPlanTemplate.querySelector(this.options.plan_selectors.right_bottom);
						let firstSell = parseFloat(plan.price) - parseFloat(plan.max_discount);
						let recurringSell = 0;
						if (plan.recurring_product) {
							recurringSell = parseFloat(plan.recurring_product.price) - parseFloat(plan.recurring_product.max_discount);
						}
						if (firstSell < recurringSell) {
							formattedRightBottom = s.it('FIRST_MONTH_THEN_RECURRING', {
								'first_sell': s.format_money(firstSell),
								'recurring_sell': s.format_money(recurringSell)
							});
							if (Number(plan.minutes) !== 0) {
								const firstPricePerMin = firstSell / plan.product_data.minutes * 100;
								const recurringPricePerMin = recurringSell / plan.product_data.minutes * 100;

								if (firstPricePerMin !== recurringPricePerMin) {
									formattedMiddle = '<span class=\'fs-14\'>';
									formattedMiddle += s.it(
										'FIRST_MONTH_THEN_RECURRING', {
											'first_sell': `${s.format_money(firstPricePerMin, true, 1)}${s.it('PER_MIN')}`,
											'recurring_sell': `${s.format_money(recurringPricePerMin, true, 1)}${s.it('PER_MIN')}`
										}
									);
									formattedMiddle += '</span>';
								} else {
									formattedMiddle = `${s.format_money(recurringPricePerMin, true, 1)}${s.it('PER_MIN')}`;
								}
							}
							rightBottom.classList.toggleClass('fs-16');
							rightBottom.classList.toggleClass('fs-14');
							rightBottom.classList.add('plan-first-then');
						}
					}
					this.options.tracking_params.destination = plan.target;
					this.options.tracking_params.product_details = formattedLeftTop;

					if (plan.product_data.destinations && plan.product_data.destinations.length > 0) {
						const countries = plan.product_data.destinations.map(destination => {
							return (destination.split('-')[0]).trim();
						});
						const uniqueCountries = countries.filter((value, index, self) => {
							return self.indexOf(value) === index;
						});
						const numberOfCountries = Math.floor(uniqueCountries.length / 10) * 10;
						if (countryCode !== 'WR') {
							const destination = typeof this.options.tariff_plan_country_list[countryCode] !== 'undefined'
								? this.options.tariff_plan_country_list[countryCode]
								: '';
							formattedLeftBottom += s.it('INCLUDE_UNLIMITED_CALLS_TO_COUNTRY', {
								destination: destination,
								number_of_countries: numberOfCountries,
							});
						} else {
							formattedLeftBottom += s.it('INCLUDE_UNLIMITED_CALLS_TO', {
								number_of_countries: numberOfCountries,
							});
						}
					}

					newPlanTemplate.querySelector(this.options.plan_selectors.left_top).innerHTML = formattedLeftTop;

					if (formattedLeftBottom !== '') {
						newPlanTemplate.querySelector(this.options.plan_selectors.left_bottom).innerHTML = formattedLeftBottom;
					} else {
						newPlanTemplate.querySelector(this.options.plan_selectors.left_bottom).remove();
					}
					if (formattedMiddle !== '') {
						newPlanTemplate.querySelector(this.options.plan_selectors.middle).innerHTML = formattedMiddle;
					} else {
						newPlanTemplate.querySelector(this.options.plan_selectors.middle).remove();
					}
					if (formattedRightTopValue) {
						newPlanTemplate.querySelector(this.options.plan_selectors.right_top_value).innerHTML = formattedRightTopValue;
					}
					if (formattedRightTopText) {
						newPlanTemplate.querySelector(this.options.plan_selectors.right_top_text).innerHTML = formattedRightTopText;
					}
					newPlanTemplate.querySelector(this.options.plan_selectors.right_top).insertAdjacentElement('afterend', document.createElement('hr'));
					newPlanTemplate.querySelector(this.options.plan_selectors.right_bottom).innerHTML = formattedRightBottom;
					newPlanTemplate.setAttribute('data-plan', plan.id);

					document.querySelector(this.options.plan_selectors.container).append(newPlanTemplate);
				});

				this.highlightBestDeal(countryCode, featured);
				this.updateBestDealText(countryCode);
			}
		}
	}

	/**
	 * Resets the styling for the _tariff_plan_section section
	 *
	 */

	resetPlans() {
		if (this.options.plan_selectors.plan_option !== 'undefined') {
			let _all_plans = document.querySelectorAll(this.options.plan_selectors.plan_option);
			if (_all_plans) {
				_all_plans.forEach( (el) => {
					el.classList.remove('active');
				});
			}
		}
		this.options.tracking_params.product_type = '';
	}

	/**
	 * Only show monthly plan if country is in World Unlimited plan
	 * This is used only for stores with one plan: World Unlimited
	 * Used for stores dianhuataiwan.com
	 */
	isCountryInWorldUnlimited(countryName) {
		const worldUnlimited = this.options.tariff_plans['WR'];

		if (!worldUnlimited) {
			return;
		}

		const destinations = worldUnlimited[0].product_data.destinations;
		if (!destinations) {
			return;
		}

		if (destinations.includes(countryName.toUpperCase())) {
			const uniqueCountries = destinations.map(destination => {
				return (destination.split('-')[0]).trim();
			}).filter((value, index, self) => {
				return self.indexOf(value) === index;
			});
			const numberOfCountries = Math.floor(uniqueCountries.length / 10) * 10;
			document.querySelector('#buy-plan-container .plan-left-bottom').textContent = s.it('INCLUDE_UNLIMITED_CALLS_TO_COUNTRY', {
				destination: countryName,
				number_of_countries: numberOfCountries,
			});
			document.getElementById('buy-now-separator')?.classList.remove('hidden');
			document.getElementById('buy-tariff-plan-section')?.classList.remove('hidden');
		} else {
			document.getElementById('buy-now-separator')?.classList.add('hidden');
			document.getElementById('buy-tariff-plan-section')?.classList.add('hidden');
		}
	}

	/**
	 * Return the plan with the best deal
	 *
	 * @param {string}   country_code    Country code for the selected country
	 *
	 * @return {Object}  the plan with the best deal
	 *
	 */

	bestPlanDeal(country_code) {
		if (country_code && country_code in this.options.tariff_plans) {
			const plans = [...this.options.tariff_plans[country_code]];

			return plans.sort((a, b) => {
				// world unlimited should be last
				if (a.product_data?.target_code?.toUpperCase() === 'WR') return 1;
				if (b.product_data?.target_code?.toUpperCase() === 'WR') return -1;

				if (a.price_per_minute === b.price_per_minute) {
					if (a.price_per_month === b.price_per_month) {
						return 0;
					}

					return a.price_per_month < b.price_per_month ? -1 : 1;

				}

				return a.price_per_minute < b.price_per_minute ? -1 : 1;

			})[0];
		}

		return null;
	}

	/**
	 * Marks the best deal plan
	 *
	 * @param {string}   country_code    Country code for the country to display the plans for
	 * @param {boolean}  select          Feature the specific plan
	 *
	 */

	highlightBestDeal(country_code, select) {
		if (country_code) {
			const _best_plan = this.bestPlanDeal(country_code);
			if (_best_plan) {
				const bestdeal_elements = document.querySelectorAll(`[data-plan='${_best_plan.id}']`);
				bestdeal_elements.forEach( bestdeal_element => {
					bestdeal_element.classList.add('plan-best-offer');
					if (select) {
						bestdeal_element.dispatchEvent(new Event('click', {bubbles: true}));
					}
				});
			}
		}
	}

	/**
	 * Return the text for the best deal for a specific country
	 *
	 * @param {string}   country_code    Country code for the selected country
	 *
	 * @return {string}  html code for the Best Deal text
	 *
	 */

	generateBestDealText(country_code) {
		let _best_deal_content = '';
		if (country_code) {
			let _best_plan = this.bestPlanDeal(country_code);
			if (_best_plan) {
				let __deal_minutes = '';
				let __deal_target = '';
				if (parseInt(_best_plan.product_data.minutes) === 0) {
					__deal_minutes = s.it('UNLIMITED_MINUTES');
				} else {
					__deal_minutes = s.format_money(_best_plan.price_per_minute * 100, true, 1) + s.it('PER_MIN');
					if (_best_plan.billing_interval_months === 1) {
						let _first_sell = parseFloat(_best_plan.price) - parseFloat(_best_plan.max_discount);
						let _recurring_sell = 0;
						if (_best_plan.recurring_product) {
							_recurring_sell = parseFloat(_best_plan.recurring_product.price) - parseFloat(_best_plan.recurring_product.max_discount);
						}
						if (_first_sell < _recurring_sell) {
							__deal_minutes = `${s.format_money(_recurring_sell / _best_plan.product_data.minutes * 100, true, 1)}${s.it('PER_MIN')}`;
						}
					}
				}
				if (typeof _best_plan.product_data.target_type !== 'undefined') {
					switch (_best_plan.product_data.target_type) {
						case 'landline':
							__deal_target = s.it('ALL_LANDLINES');
							break;

						case 'mobile':
							__deal_target = s.it('ALL_MOBILES');
							break;

						default:
							__deal_target = s.it('ALL_NUMBERS');
							break;
					}
				}
				_best_deal_content = `<strong>${s.it('BEST_DEAL')}:</strong> ${__deal_minutes} - ${__deal_target}`;
			}
		}

		return _best_deal_content;
	}

	updateBestDealText(country_code) {
		if (typeof this.options.page_selectors.best_offer_text_holder !== 'undefined') {
			let _plan_subtitle = document.getElementById(this.options.page_selectors.best_offer_text_holder);
			if (_plan_subtitle) {
				if (country_code) {
					_plan_subtitle.innerHTML = this.generateBestDealText(country_code);
				} else {
					_plan_subtitle.innerHTML = _plan_subtitle.dataset.initialText;
				}
			}
		}
	}

	/**
	 * Handles events on the page ( click/change/etc to call the right functions at the right time )
	 */

	changeVoiceDestination(country_name) {
		//console.log('TariffPlan::changeVoiceDestination(%o)', country_name);
		if (typeof s.voice_credit !== 'undefined') {
			const _credit_sell_countries = document.getElementById(s.voice_credit.options.credit_sell_countries_id);
			if (_credit_sell_countries) {
				for (let _i = 0;_i < _credit_sell_countries.length;_i++) {
					if (_credit_sell_countries.options[_i].value === country_name) {
						_credit_sell_countries.value = country_name;
						_credit_sell_countries.classList.remove('has-placeholder');
						s.common.changeFlag(_credit_sell_countries);
						s.voice_credit.getCountryRates(country_name, true);
					}
				}
			}
		}
	}
	pageEvents() {
		if (typeof this.options.page_selectors.plan_sell_countries_id !== 'undefined') {
			const _plan_sell_countries = document.getElementById(this.options.page_selectors.plan_sell_countries_id);
			if (_plan_sell_countries ) {
				_plan_sell_countries.addEventListener('change', () => {
					this.displayCountryPlans(
						_plan_sell_countries.options[_plan_sell_countries.selectedIndex].getAttribute('data-country-code'),
						true
					);
					if (_plan_sell_countries.value) {
						this.changeVoiceDestination(_plan_sell_countries.value);
					}
				});
			}
		}

		if (typeof this.options.plan_selectors.plan_option !== 'undefined') {
			document.addEventListener('click', (event) => {
				const planOption = event.target.closest(this.options.plan_selectors.plan_option);
				if (!planOption) {
					return;
				}
				document.querySelectorAll(this.options.plan_selectors.plan_option).forEach(e => e.classList.remove('active'));
				planOption.classList.add('active');
				const ivd = document.getElementById(this.options.buy_form_selectors.voice_quantity);
				if (ivd) {
					ivd.value = '1';
				}
				const ivpi = document.getElementById(this.options.buy_form_selectors.voice_product_id);
				if (ivpi) {
					ivpi.value = planOption.getAttribute('data-plan');
				}
				const ivbi = document.getElementById(this.options.buy_form_selectors.buy_button_id);
				if (ivbi) {
					ivbi.disabled = false
				}
				this.options.tracking_params.product_type = 'tariff_plan';
				if (typeof s.voice_credit_section !== 'undefined') {
					s.voice_credit_section.resetPredefined();
					s.voice_credit_section.resetCustom();
				}
				if (typeof s.voice_credit !== 'undefined') {
					s.voice_credit.resetPredefined();
				}
			});
		}

		if (typeof this.options.page_selectors.product_selector_id !== 'undefined') {
			let _product_selector = document.getElementById(this.options.page_selectors.product_selector_id);
			if (_product_selector) {
				_product_selector.addEventListener('change', () => {
					document.getElementById(this.options.buy_form_selectors.buy_button_id).disabled = true;
					const planOptions = document.querySelectorAll(this.options.plan_selectors.plan_option);
					if (planOptions.length === 1) {
						planOptions[0].classList.add('active');
					}
					
					if (Array.from(planOptions).some(el => el.classList.contains('active'))) {
						document.getElementById(this.options.buy_form_selectors.voice_quantity).value = '1';
						document.getElementById(this.options.buy_form_selectors.voice_product_id).value =
							document.querySelector(this.options.plan_selectors.plan_option + '.active').getAttribute('data-plan');
						document.getElementById(this.options.buy_form_selectors.buy_button_id).disabled = false;
					}
					if (typeof s.voice_credit_section !== 'undefined') {
						s.voice_credit_section.resetPredefined();
						s.voice_credit_section.resetCustom();
					}
					if (typeof s.voice_credit !== 'undefined') {
						s.voice_credit.resetPredefined();
					}
				});
			}
		}

		if (this.options.buy_form_selectors.buy_button_id !== 'undefined') {
			let _submit_button = document.getElementById(this.options.buy_form_selectors.buy_button_id);
			if (_submit_button) {
				_submit_button.addEventListener('click', () => {
					if (this.options.tracking_params && this.options.tracking_params.product_type) {
						s.track.dataLayerPush({
							'event': 'gtm_remarketing',
							'destination': this.options.tracking_params.destination,
							'product_type': this.options.tracking_params.product_type,
							'product_details': this.options.tracking_params.product_details,
							'dynx_pagetype': 'conversionintent'
						});
					}
				});
			}
		}

		let selected_credit_country_name = '';
		let selected_tariff_plan_country_code = '';
		if (this.options.selected_country) {
			selected_credit_country_name = this.options.selected_country.name;
			if (Object.keys(this.options.tariff_plans).includes(this.options.selected_country.short)) {
				selected_tariff_plan_country_code = this.options.selected_country.short;
			} else {
				const _plan_sell_countries = document.getElementById(this.options.page_selectors.plan_sell_countries_id);
				if (!_plan_sell_countries) {
					selected_tariff_plan_country_code = Object.keys(this.options.tariff_plans)[0];
				}
			}
		}

		this.displayCountryPlans(selected_tariff_plan_country_code, this.options.featured);
		this.changeVoiceDestination(selected_credit_country_name);
	}
}
